import { count } from '../stores.js'
import PackagesComponent from '../components/packages.svelte'

const { $ } = window

function packagesSelection() {
	let activeSelection = document.querySelector('.package-nav--active')
	if (!activeSelection) return
	let animating = false
	function showDropdown(e) {
		if (animating) return
		animating = true
		e.target.closest('.packages-nav--wrap').classList.toggle('active')
		setTimeout(() => {
			animating = false
		}, 300)
	}
	function toggleDropdownListener(x) {
		x.matches
			? activeSelection.addEventListener('click', showDropdown)
			: activeSelection.removeEventListener('click', showDropdown)
	}

	var x = window.matchMedia("(max-width: 1024px)")
	toggleDropdownListener(x)
	x.addListener(toggleDropdownListener)
}

function packages() {
	const $packagesComponent = $('#packages-component')
	if (!$packagesComponent.length) {
		return
	}

	new PackagesComponent({
		target: $packagesComponent[0],
		props: $packagesComponent.data(),
	})

	const $packagesButtons = $('.packages-nav li')
	$packagesButtons.eq(sessionStorage.getItem('tierSelection') || 0).addClass('active')
	const tmpidx = sessionStorage.getItem('tierSelection') ? +sessionStorage.getItem('tierSelection') + 1 : '1'
	$('.package-nav--active').find('span').text('Tier ' + tmpidx)
	$('.packages-nav li').on('click', function (e) {
		$packagesButtons.removeClass('active')
		this.classList.add('active')
		count.update((_) => {
			console.log(e.target, +$(e.target).data('index'))
			sessionStorage.setItem('tierSelection', +$(e.target).data('index'))
			return parseInt($(e.target).data('index'))
		})
	})

	//assumes existence
	function itemClick() {
		$('.packages-nav--wrap').removeClass('active')
		$('.package-nav--active').find('span').text('Tier ' + $(this).text())
	}
	function outsideClick(e) {
		if (!$(e.target).parent('.packages-nav--wrap').length) {
			$('.packages-nav--wrap').removeClass('active')
		}
	}
	function toggleSelection(x) {
		if (x.matches) {
			$('.packages-nav li').on('click', itemClick)
			$(window).on('click', outsideClick)
		} else {
			$('.packages-nav li').off('click', itemClick)
			$(window).off('click', outsideClick)
			$('.packages-nav--wrap').removeClass('active')
			const tmpidx = sessionStorage.getItem('tierSelection') ? +sessionStorage.getItem('tierSelection') + 1 : '1'
			$('.package-nav--active').find('span').text('Tier ' + tmpidx)
		}
	}

	var x = window.matchMedia("(max-width: 1024px)")
	toggleSelection(x)
	x.addListener(toggleSelection)
}

/**
 * Home Page Slider
 * 
 */
function reviews() {
	const $reviewWrap = $('.reviews-preview--wrap')
	if (!$reviewWrap.length) {
		return
	}

	$reviewWrap.slick({
		adaptiveHeight: true,
		arrows: false,
		dots: true,
		fade: true,
		infinite: true,
		speed: 300,
		slidesToShow: 1,
	})

	$reviewWrap.find('.review').map((_idx, el) => {
		if ($(el).find('.review--content-wrap').children().length > 1) {
			el.classList.add('has-more')
		}
	})

	$('.review--read-more').on('click', function (e) {
		e.preventDefault()
		$(e.target).siblings('.review--content-wrap').addClass('active')
		const idx = $reviewWrap.slick('slickCurrentSlide')
		$reviewWrap.slick('unslick')
		$reviewWrap.slick({
			adaptiveHeight: true,
			arrows: false,
			dots: true,
			fade: true,
			infinite: true,
			speed: 300,
			slidesToShow: 1,
		})
		$reviewWrap.slick('slickGoTo', idx)
	})
}

function services() {
	const selector = '.services-preview--wrap'
	const $serviceWrap = $(selector)
	if (!$serviceWrap.length) {
		return
	}

	function setupRotator() {
		$serviceWrap.slick({
			arrows: false,
			dots: true,
			infinite: true,
			speed: 300,
			slidesToShow: 3,
			slidesToScroll: 3,
			touchThreshold: 100,
			vertical: true,
			verticalSwiping: true,
		})
	}

	let timeout
	$(window).resize(function (e) {
		clearTimeout(timeout)
		timeout = setTimeout(function () {
			$(`${selector}.slick-initialized`).slick('unslick')
			setupRotator()
		}, 50)
	})
	setupRotator()

	//Dinstinguish click from drag
	const delta = 6
	let startX
	let startY

	$serviceWrap.find('.slick-track').on('mousedown', function (event) {
		startX = event.pageX
		startY = event.pageY
	})

	$serviceWrap.find('.slick-track').on('mouseup', function (event) {
		const diffX = Math.abs(event.pageX - startX)
		const diffY = Math.abs(event.pageY - startY)
	})
}

function caseStudies() {
	const $caseStudiesWrap = $('.case-studies-wrap')
	if (!$caseStudiesWrap.length) {
		return
	}

	$caseStudiesWrap.slick({
		arrows: false,
		autoplay: true,
		autoplaySpeed: 5000,
		dots: true,
		fade: true,
		infinite: true,
		speed: 300,
		slidesToShow: 1,
		adaptiveHeight: true,
	})
}

function clientReviews() {
	const $clientReviewWrap = $('.client-review-wrap')
	if (!$clientReviewWrap.length) {
		return
	}

	$clientReviewWrap.slick({
		arrows: true,
		prevArrow: '<button class="slick-prev slick-arrow" aria-label="previous" type="button"><span class="sr-only">previous</span><svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"> <g id="Group_386" data-name="Group 386" transform="translate(1252 1902) rotate(180)"> <circle id="Ellipse_23" data-name="Ellipse 23" cx="18" cy="18" r="18" transform="translate(1252 1902) rotate(180)" fill="#62929e"/> <path id="Icon_awesome-arrow-left" data-name="Icon awesome-arrow-left" d="M9.518,17.711l-.821.821a.884.884,0,0,1-1.253,0L.257,11.348a.884.884,0,0,1,0-1.253L7.444,2.908a.884.884,0,0,1,1.253,0l.821.821A.888.888,0,0,1,9.5,5L5.048,9.241H15.674a.885.885,0,0,1,.887.887v1.183a.885.885,0,0,1-.887.887H5.048L9.5,16.443A.882.882,0,0,1,9.518,17.711Z" transform="translate(1242.279 1894.72) rotate(180)" fill="#fff"/> </g> </svg> </button>',
		nextArrow: '<button class="slick-next slick-arrow" aria-label="next" type="button"><span class="sr-only">next</span><svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"> <g id="Group_385" data-name="Group 385" transform="translate(-1216 -1866)"> <circle id="Ellipse_23" data-name="Ellipse 23" cx="18" cy="18" r="18" transform="translate(1252 1902) rotate(180)" fill="#62929e"/> <path id="Icon_awesome-arrow-left" data-name="Icon awesome-arrow-left" d="M9.518,17.711l-.821.821a.884.884,0,0,1-1.253,0L.257,11.348a.884.884,0,0,1,0-1.253L7.444,2.908a.884.884,0,0,1,1.253,0l.821.821A.888.888,0,0,1,9.5,5L5.048,9.241H15.674a.885.885,0,0,1,.887.887v1.183a.885.885,0,0,1-.887.887H5.048L9.5,16.443A.882.882,0,0,1,9.518,17.711Z" transform="translate(1242.279 1894.72) rotate(180)" fill="#fff"/> </g> </svg></button>',
		adaptiveHeight: true,
		dots: false,
		fade: true,
		infinite: true,
		speed: 300,
		slidesToShow: 1,
		swipe: false,
	})

	const prev = document
		.querySelector('.client-review-wrap.slick-initialized')
		.removeChild(document.querySelector('.slick-arrow.slick-prev'))
	const next = document
		.querySelector('.client-review-wrap.slick-initialized')
		.removeChild(document.querySelector('.slick-arrow.slick-next'))
	$('.slick-slide .slick-arrows-wrap').append(prev)
	$('.slick-slide .slick-arrows-wrap').append(next)
}

/**
 */
function runBlocks() {
	//home, etc.
	packagesSelection()
	packages()
	reviews()
	services()

	//reviews
	caseStudies()
	clientReviews()
}

export { runBlocks }
